/** ダイアログデフォルト定数 */
export const DIALOG_DEFAULT_CONSTANT = {
  // 'はい'ボタン文言
  yes: 'はい',
  // 'いいえ'ボタン文言
  no: 'いいえ',

  TXT_DELETE: '削除'
};
